import React, { useState, useEffect } from "react";
import logo from "../../assets/logoletoh2.png";
import amex from "../../assets/AMEX.png";
import Bancolombia from "../../assets/Bancolombia.png";
import Instagram from "../../assets/Instagram.png";
import MC from "../../assets/MC.png";
import Nequi from "../../assets/Nequi.png";
import PSE from "../../assets/PSE.png";
import VISA from "../../assets/VISA.png";
import ws from '../../assets/WA.png';

import getCompany from '../../services/getCompany';
import GTranslateWidget from "../gtranslatewidget/GTranslateWidget";

const Footer = (info) => {
  const [company, setCompany] = useState({})

  const getInfo = async () => {
    try {
      const responseCompany = await getCompany();
      setCompany(responseCompany[0]);
    } catch (error) {
    }
  };

  useEffect(() => {
    getInfo()
  }, []);


  return (
    <footer className="bg-[#005C59] text-white py-6 text-center font-poppins mt-4">
      <GTranslateWidget />
      <div className="flex justify-center mt-2 mb-8">
        <img src={logo} alt="Letoh Logo" className="w-32" />
      </div>

      {/* Contenido en columnas para escritorio */}
      <div className="container mx-auto px-6 md:grid md:grid-cols-2 md:w-[70%] md:text-left ">
        <div className="flex flex-col items-center md:items-start md:pl-14">
          <h3 className="text-lg font-semibold">Contacto</h3>
          <a
            href={`mailto:${company.email}`}
            className="text-base font-normal leading-[1.1] mt-0.5 text-inherit"
          >
            {company.email}
          </a>
          <a
            href={`tel:+57${company.phone}`}
            className="text-base font-normal leading-[1.1] mt-3 mb-4 pb-2 text-inherit"
          >
            {`(+57) ${company.phone}`}
          </a>
        </div>

        <div className="flex flex-col items-center mb-4 pb-3">
          <h3 className="text-lg font-semibold">Métodos de pago</h3>
          <div className="flex justify-center space-x-3 mt-2">
            <img src={MC} alt="MasterCard" className="w-10 h-6 object-contain" />
            <img src={VISA} alt="VISA" className="w-12 h-6 object-contain" />
            <img src={amex} alt="American Express" className="w-8 h-6 object-contain" />
            <img src={Bancolombia} alt="Bancolombia" className="w-9 h-6 object-contain" />
            <img src={PSE} alt="PSE" className="w-14 h-6 object-contain" />
            <img src={Nequi} alt="PSE" className="w-14 h-6 object-contain" />
          </div>
        </div>

        {/* Enlaces */}
        {/* <div className="flex flex-col items-center md:items-start md:pl-10">
          <p className="text-lg font-semibold cursor-pointer hover:underline mb-2">
            Contrato de cumplimiento
          </p>
          <p className="text-lg font-semibold cursor-pointer hover:underline">
            Políticas de privacidad
          </p>
        </div> */}
      </div>

      <div className="mt-6 flex flex-col items-center mt-1">
        <a href={company.instagram} target="_blank" rel="noopener noreferrer">
          <img src={Instagram} alt="Instagram" className="w-9 h-9 mb-1" />
        </a>
        <p className="text-base font-normal">letoh.co</p>
      </div>
      <a
        href={`https://wa.me/${company.phone}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 md:bottom-6 md:right-6 lg:bottom-8 lg:right-8 z-50"
      >
        <img
          src={ws}
          alt="WhatsApp"
          className="w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 drop-shadow-lg hover:scale-110 transition-transform"
        />
      </a>
    </footer>
  );
};

export default Footer;
